module.exports = __webpack_public_path__ + "static/media/20231026-DSC_5114.39140fd9.jpg";